import React from 'react';

export default function KairosisLogo({ size = 'md', showText = true, className = '' }) {
  const sizes = {
    sm: { box: 'w-8 h-8', icon: 28, text: 'text-base' },
    md: { box: 'w-10 h-10', icon: 34, text: 'text-xl' },
    lg: { box: 'w-14 h-14', icon: 48, text: 'text-2xl' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div
        className={`${s.box} relative rounded-2xl flex items-center justify-center shrink-0`}
        style={{
          background: 'linear-gradient(135deg, #00E676 0%, #00BFA5 40%, #007AFF 100%)',
          boxShadow: '0 0 24px rgba(0,230,118,0.35), inset 0 1px 0 rgba(255,255,255,0.25)',
        }}
      >
        <svg width={s.icon} height={s.icon} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10 8H16L22 20L28 8H34L24 22L34 32H28L22 24L16 32H10L20 22L10 8Z"
            fill="#050505"
            opacity="0.9"
          />
          <path
            d="M26 26L32 32"
            stroke="#050505"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          <circle cx="30" cy="30" r="2" fill="#050505" />
        </svg>
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-transparent to-white/10 pointer-events-none" />
      </div>
      {showText && (
        <span className={`${s.text} font-bold tracking-tight leading-none`}>
          Kairosis<span className="text-[#71717A] font-light">Capital</span>
        </span>
      )}
    </div>
  );
}
